/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Category_SpeakersInputs */

const he_home_category_speakers = /** @type {(inputs: Home_Category_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`רמקולים`)
};

const en_home_category_speakers = /** @type {(inputs: Home_Category_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speakers`)
};

/**
* | output |
* | --- |
* | "Speakers" |
*
* @param {Home_Category_SpeakersInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const home_category_speakers = /** @type {((inputs?: Home_Category_SpeakersInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Category_SpeakersInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_home_category_speakers(inputs)
	return en_home_category_speakers(inputs)
});